import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link,  } from "react-router-dom";
import { Col } from "react-bootstrap";
import ShowSkeleton from "../utils/helpers/skeleton";
import {getGeneralInfo,editGeneralInfo} from "../store/slices/mpd";


const GeneralInfo = () => {

  const [isloading, setisLoading] = useState(false);
  const dispatch = useDispatch();

const [formData, setFormData] = useState({
  schoolName: "",
  address: "",
  principalName: "",
  qualification: "",
  email: "",
  mobileNumber: "",
});

const getInfo = () => {
  dispatch(getGeneralInfo())
    .unwrap()
    .then((response) => {
      setFormData(response?.data || {});
    })
    .catch(({ message }) => console.error(message))
    .finally(() => {
      setisLoading(false);
    });
};

useEffect(() => {
  dispatch(getGeneralInfo())
    .unwrap()
    .then((response) => {
      setFormData(response.data);
    });
}, []);

const handleChange = (e) => {
  setFormData({
    ...formData,
    [e.target.name]: e.target.value,
  });
};


const handleSubmit = (e) => {
  e.preventDefault();

  dispatch(editGeneralInfo(formData))
    .unwrap()
    .then(() => {
      alert("General Information Updated");
      getInfo();
    })
    .catch((err) => {
      alert(err.message);
    });
};

  return (
    <>
     
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">General Information</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/home"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Home
            </Link>
          </li>
          <li> &gt;</li>
          <li className="fw-medium">General Information</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-header  bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3"></div>
         
        </div>
      <div className="card-body px-24 py-24">
  {isloading ? (
    <Col lg={12} xs={12} md={12} align="center">
      {ShowSkeleton()}
    </Col>
  ) : (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-6 mb-20">
          <label className="form-label">School Name</label>
          <input
            type="text"
            className="form-control"
            name="schoolName" maxLength={100}
            value={formData.schoolName || ""}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6 mb-20">
          <label className="form-label">Principal Name</label>
          <input
            type="text"
            className="form-control"
            name="principalName" maxLength={100}
            value={formData.principalName || ""}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-12 mb-20">
          <label className="form-label">Address</label>
          <textarea
            className="form-control"
            rows="3" maxLength={200}
            name="address"
            value={formData.address || ""}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6 mb-20">
          <label className="form-label">Qualification</label>
          <input
            type="text"
            className="form-control"
            name="qualification"
            maxLength={70}
            value={formData.qualification || ""}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6 mb-20">
          <label className="form-label">Email</label>
          <input
            type="text" maxLength={100}
            className="form-control"
            name="email"
            value={formData.email || ""}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6 mb-20">
          <label className="form-label">Mobile Number</label>
          <input
            type="text"
            className="form-control" maxLength={30}
            name="mobileNumber"
            value={formData.mobileNumber || ""}
            onChange={handleChange}
          />
        </div>

        <div className="col-12 mt-3">
          <button
            type="submit"
            className="btn btn-primary py-2 px-5"
          >
           Update
          </button>
        </div>
      </div>
    </form>
  )}
</div>
      </div>
    </>
  );
};

export default GeneralInfo;
